var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-scroll-ranking-board',{style:({width:_vm.width+'px',height:_vm.height+'px'}),attrs:{"config":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }